module.exports = __webpack_public_path__ + "static/media/cdap_start2.0fa66f3e.svg";